// extracted by mini-css-extract-plugin
export default {"wrapper":"promoProducts_wrapper__0sHXz","title":"promoProducts_title__v1zE8"};